export const GET_FOOTER_DATA = `
  query GetFooterData {
    footer {
      links {
        url
        title
        target
      }
      social {
        icon
        url
      }
      copyright
    }
  }
`;
